import { Chip, type ChipProps } from '@mui/material';
import { Pencil } from 'lucide-react';

export const chipStyle = {
  '& .MuiChip-label': {
    fontWeight: 'medium',
  },
};

type EditableChipProps = Omit<ChipProps, 'deleteIcon' | 'onDelete'> & {
  onEdit?: () => void;
};

export const EditableChip = ({ onEdit, ...props }: EditableChipProps) => {
  return (
    <Chip
      {...props}
      onClick={onEdit}
      deleteIcon={<Pencil size={14} />}
      onDelete={onEdit}
      sx={[
        {
          '& .MuiChip-icon': {
            marginLeft: '10px',
          },
          '& .MuiChip-deleteIcon': {
            marginRight: '10px',
            color: 'text.disabled',
            '&:hover': {
              color: 'text.secondary',
            },
          },
        },
        ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : []),
      ]}
    />
  );
};
